<app-spinner></app-spinner>
<div class="container-fluid">
  <div class="row mt-2">
    <div class="col-12">
      <h4 style="font-weight:bold;">Total Complaints</h4>
    </div>

  </div>

  <div class="row mt-4">
    <div class="col-8">
      <input type="text" class="form-control fontAwesome" style="padding: 8px;" [(ngModel)]="searchText"
        (keyup)="applyFilters()" placeholder="Search by zone , Ward , create date">
    </div>
    <div class="col-4 add-Complaint">
      <button class="hover-light" style="background-color: #226CE0; color: white; " mat-raised-button
        routerLink="/sdp/operator/new-compliants"><i class="fa fa-plus"></i> <span> &nbsp;Add New
          Complaints</span></button> &nbsp; &nbsp;
      <button style="background-color: #b5b5b5; color: white; width: 42%;" mat-raised-button
        (click)="exportToExcel()"><i class="fa fa-file "></i> <span> &nbsp;Export</span></button>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">

      <div class="table-responsive">
        <table class="table table-bordered w-100 tableshadow">
          <thead class="table table-light">
            <tr>
              <th class="text-center">Sr.No.</th>
              <th class="text-center">Ticket Id</th>
              <!-- <th class="text-center">Department</th> -->
              <th class="text-center">Zone</th>
              <th class="text-center">Ward</th>
              <th class="text-center">Create date</th>
              <th class="text-center">Days Open</th>
              <th class="text-center">Status</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let  obj of showComplaints; let i=index">
              <td class="text-center">{{ showComplaints.length-i }}</td>
              <td class="text-center">{{ obj.ticket_id }}</td>
              <!-- <td class="text-center">{{ obj.departments }}</td> -->
              <td class="text-center">{{ obj.zone }}</td>
              <td class="text-center">{{ obj.ward }}</td>
              <td class="text-center">{{ obj.create_date }}</td>
              <td class="text-center">{{ obj.number_of_open_days }}</td>
              <td class="text-center">{{ obj.status }}</td>

              <td class="text-center"
                style="position: relative;  align-items: center; justify-content: center;gap: 10px;">
                <div style="justify-content: center;display: flex;align-items: center;gap: 10px;">
                  <span class="view"
                    style="color: rgb(0, 26, 255); text-decoration: underline; cursor: pointer; margin: 5px 0;"
                    (click)="route(obj)" title="View detailed information">
                    <strong>View More</strong>
                  </span>


                  <span class="more-dots" (click)="togglePrintOption(obj)"
                    style="cursor: pointer; font-size: 20px; color: rgb(0, 26, 255); user-select: none;">
                    <strong>&#8942;</strong>
                  </span>

                </div>
                <div *ngIf="activeRow === obj" class="tooltip-print"
                  style="position: absolute; top: 30px; right: 0; background: whitesmoke; color: rgb(1, 159, 244); text-decoration: underline;font-size: 14px; padding: 15px; cursor: pointer;  box-shadow: -1px 1px 4px 0px rgba(136, 132, 161, 0.25), 1px -1px 4px 0px rgba(136, 132, 161, 0.25), -1px -1px 4px 0px rgba(136, 132, 161, 0.25), 1px 1px 4px 0px rgba(136, 132, 161, 0.25); z-index: 1;"
                  (click)="onDownloadPDF(obj); closePrintOption()" title="Print form as PDF">
                  Print Form
                </div>
              </td>


              <!-- style="border-radius: 6px;" -->
              <!-- [ngStyle]="{'color': obj.status === 'Active' ? '#226CE0' : '#226CE0', 'color': 'white' }" -->
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
        <span style="color: #6D6D6D; font-size: 14px;">
          Showing {{ complaints.length }} of {{ allComplaints.length }} departments
        </span>

        <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
          <label class="me-1">Per page:</label>
          <select [(ngModel)]="pageSize" (change)="changePageSize()" class="form-select form-select-sm w-auto">
            <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
          </select>

          <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()"
            [disabled]="currentPage === 1">&lt;</button>

          <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

          <button class="btn-sm fw-bold px-3 py-1" (click)="nextPage()"
            [disabled]="currentPage === totalPages">&gt;</button>
        </div>
      </div>
      <!-- <div class="shadow-wrapper"> 
                <table mat-table  [dataSource]="complaints" class="mat-elevation-z8" style="width: 100%;">

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>ID</th>
                        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
 
                    <ng-container matColumnDef="dept">
                        <th mat-header-cell *matHeaderCellDef>Department</th>
                        <td mat-cell *matCellDef="let element">{{ element.dept }}</td>
                    </ng-container>

                  
                    <ng-container matColumnDef="zone">
                        <th mat-header-cell *matHeaderCellDef>Zone</th>
                        <td mat-cell *matCellDef="let element">{{ element.zone }}</td>
                    </ng-container>

                    
                    <ng-container matColumnDef="ward">
                        <th mat-header-cell *matHeaderCellDef>Ward</th>
                        <td mat-cell *matCellDef="let element">{{ element.ward }}</td>
                    </ng-container>

                    
                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>Create date</th>
                        <td mat-cell *matCellDef="let element" class="created">{{ element.create_date }}</td>
                    </ng-container>

                   
                    <ng-container matColumnDef="days_Open">
                        <th mat-header-cell *matHeaderCellDef>Days Open</th>
                        <td mat-cell *matCellDef="let element" class="center1">{{ element.number_of_open_days }}</td>
                    </ng-container>
                    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>
            </div> -->
    </div>
  </div>
</div>